import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { TRANSLATIONS, LANGUAGES } from "./translations";

const LanguageContext = createContext(null);

const STORAGE_KEY = "sxg-lang";

const detect = () => {
  if (typeof window === "undefined") return "fr";
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored && TRANSLATIONS[stored]) return stored;
  const nav = (navigator.language || "fr").slice(0, 2);
  return TRANSLATIONS[nav] ? nav : "fr";
};

// Walk dotted path, e.g. "hero.title1"
const get = (obj, path) =>
  path.split(".").reduce((acc, k) => (acc != null ? acc[k] : undefined), obj);

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(detect);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const value = useMemo(() => {
    const dict = TRANSLATIONS[lang] || TRANSLATIONS.fr;
    const t = (path, vars = {}) => {
      let v = get(dict, path);
      if (v == null) v = get(TRANSLATIONS.fr, path);
      if (typeof v === "string" && Object.keys(vars).length) {
        v = v.replace(/\{(\w+)\}/g, (_, k) => (vars[k] != null ? vars[k] : ""));
      }
      return v;
    };
    return { lang, setLang: setLangState, t, languages: LANGUAGES };
  }, [lang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used within LanguageProvider");
  return ctx;
};
